// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13C0g","controls":"styles_controls__1twkW","charLimit":"styles_charLimit__3_Vif","input":"styles_input__2GTVo","send":"styles_send__1yPI0"};